import actionTypes from '../constants/action-types';

const hide = () => ({
  type: actionTypes.HIDE_DIALOG,
});

export default hide;
